import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../helpers/common.service';
import { StarConvertService } from '../../../helpers/star-convertor.service';
import { ImageDialogComponent } from '../../bookings/booking-overview/booking-overview.component';
import { BookingDetails } from '../../bookings/booking.models';
import { BookingService } from '../../bookings/booking.service';

@Component({
  selector: 'app-review-overview',
  templateUrl: './review-overview.component.html',
  styleUrl: './review-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush, // Use OnPush strategy
})
export class ReviewOverviewComponent implements OnInit, OnDestroy {
  @Output() showBookingsData = new EventEmitter<boolean>()
  serviceType?: string = '';
  overViewDetails: BookingDetails | null = null;
  @Input() isLoading: boolean;
  declarationImage: any = [];
  companyId: number = 0;

  constructor(private bookingService: BookingService,
    private starConvertService: StarConvertService,
    private commonService: CommonService, private dialog: MatDialog,
    private cdr: ChangeDetectorRef) {
    this.serviceType = this.overViewDetails?.serviceType
  }

  bookingsGrid() {
    this.showBookingsData.emit(true);
  }

  getStatusClass(statusName: string): string {
    if (!statusName) {
      return '';  // Return an empty class if status is not available
    }
    return this.commonService.getStatusClass(statusName);
  }

  getStatusIcon(statusName: string): string {
    if (!statusName) {
      return '/assets/images/icons-kpi-dashboard/default-icon.png'; // Default icon if status is not available
    }
    return this.commonService.getStatusIcon(statusName);
  }

  ngOnInit(): void {
    const companyIdval = localStorage.getItem('companyId');
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;

    this.bookingService.bookingOverviewDetails.subscribe((overview: BookingDetails | null) => {
      if (overview) {
        const updatedOverview = { ...overview };

        if (updatedOverview.rating <= 0) {
          updatedOverview['starRating'] = 'No rating';
        } else {
          updatedOverview['starRating'] = this.starConvertService.convertDecimalNumberToStars(updatedOverview.rating) + ` <span class="star-rating-value-msg">(${updatedOverview.rating})</span>`
        }
        this.overViewDetails = updatedOverview
        this.isLoading = false
      }

    });
    this.getImagesofDeclaration(this.overViewDetails?.taskId)
  }

  getImagesofDeclaration(imageData: any) {
    imageData = this.overViewDetails?.taskId;
    this.bookingService.getImagesofDeclaration(imageData, this.companyId).subscribe((details: any[]) => {
      this.declarationImage = details
      this.cdr.detectChanges();
    },
      (error) => {
        console.error('Error fetching booking details:', error);
      }
    );
  }
  ngOnDestroy(): void {

  }

  openImageDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      width: '80%',
      height: '80%',
      data: {
        images: this.declarationImage,
        currentIndex: index,
      }
    });
  }
}
